import styled from 'styled-components';
import { prop } from 'ramda';
import { animatedPlaceholder, fillAbsolute } from '../../../theme/mixins';

export const Container = styled.div`
  position: relative;
`;

export const ContainerBackground = styled.div`
  padding-top: ${({ ratio }) => (ratio ? `${ratio * 100}%` : null)};
  ${animatedPlaceholder};
  ${prop('extraStyle')};
`;

export const Placeholder = styled.div`
  ${fillAbsolute};
`;

export const Img = styled.img`
  ${fillAbsolute};
  width: 100%;
  height: auto;
  transition: opacity 0.3s ease-in-out;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  ${prop('extraStyle')};
`;
